import { Injectable } from '@angular/core';

type RGBValues = {
  r: number;
  g: number;
  b: number;
};

@Injectable({ providedIn: 'root' })
export class ColorUtilsService {
  private getRGBValuesFromRGBString(color: string): RGBValues {
    const [_, r, g, b] = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)?.map(value => parseInt(value));
    return { r, g, b };
  }

  private getRGBValuesFromHex(color: string): RGBValues {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    const rgbBitwise = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

    const r = rgbBitwise >> 16;
    const g = (rgbBitwise >> 8) & 255;
    const b = rgbBitwise & 255;
    return { r, g, b };
  }

  public isColorLightOrDark(color: string, threshold: number = 175): 'light' | 'dark' {
    if (!Boolean(color)) {
      return;
    }

    try {
      // Check the format of the color, HEX or RGB?
      const isRGBString = color.match(/^rgb/);

      const { r, g, b } = isRGBString ? this.getRGBValuesFromRGBString(color) : this.getRGBValuesFromHex(color);

      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

      // Using the HSP value, determine whether the color is light or dark
      return hsp > threshold ? 'light' : 'dark';
    } catch (error) {
      console.error(error);
      return 'light';
    }
  }
}
